import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { CELIA_BOT_URL } from "../../lib/celia";
import { resolveQrZone, trackPageview } from "../../lib/qrTracking";

export default function CeliaRedirect() {
  const { search } = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(search);
    const zone = resolveQrZone(params.get("qr"));

    trackPageview("/celia", zone)
      .catch(() => {})
      .finally(() => {
        window.location.replace(CELIA_BOT_URL);
      });
  }, [search]);

  return null;
}
